export default "__VITE_ASSET__BV9Iv6tS__"